import { useQuery } from '@tanstack/react-query';
import { trpc } from '@/utils/trpc';
import type { EfaxSourcePdfLinkRequest } from '../types';

export const useEfaxSourcePdfLink = (
  request: EfaxSourcePdfLinkRequest,
  options?: { enabled?: boolean },
) =>
  useQuery({
    ...trpc.recordUploadRouter.getAnonymousRecordFaxSourcePdfLink.queryOptions(
      request,
    ),
    enabled: options?.enabled ?? false,
    retry: false,
  });
